/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { ORDERS: de },
  'el-GR': { ORDERS: el },
  'en-US': { ORDERS: en },
  'es-ES': { ORDERS: es },
  'fi-FI': { ORDERS: fi },
  'fr-FR': { ORDERS: fr },
  'it-IT': { ORDERS: it },
  'pl-PL': { ORDERS: pl },
  'pt-PT': { ORDERS: pt }
};
